<div
  class="form-control__wrapper"
  [ngClass]="{ 'form-control__wrapper--flat': direction === 'filter' }"
>
  <label class="form-control__label">
    <p class="t-bold">{{ config.label }}</p>
  </label>

  <div class="u-relative" [formGroup]="group">
    <input
      class="form-control"
      [ngClass]="{ 'form-control--icon-right': speechRecognition.recognition }"
      [formControl]="group.get(config.prop)"
    />

    @if (speechRecognition.recognition) {
      <div class="form-control__icon form-control__icon--right">
        <icon
          name="mic"
          [config]="{ fill: 'fc-icon-color', type: 'pointer' }"
          (click)="startSpeechRecognition()"
        >
        </icon>
      </div>
    }
  </div>
</div>

@if (speechRecognition.isListening) {
  <section @fade class="SpeechRecognition">
    <div class="SpeechRecognition__ripple" (click)="stopSpeechRecognition()">
      <icon
        class="SpeechRecognition__icon"
        name="mic"
        [config]="{ size: 'large', type: 'pointer' }"
      >
      </icon>
    </div>
    <h1>
      @if (!speechRecognition.text && !speechRecognition.interimText) {
        {{ config.prompt || 'Say something' }}
      }
      {{ speechRecognition.text }} {{ speechRecognition.interimText }}
    </h1>
  </section>
}
